// extracted by mini-css-extract-plugin
export var form = "R9y3SoUH";
export var formTitleContainer = "QXyV9mYy";
export var borderDivider = "d76Ln3-F";